import { render, staticRenderFns } from "./chickenExchange.vue?vue&type=template&id=60ed9292&scoped=true&"
import script from "./chickenExchange.vue?vue&type=script&lang=js&"
export * from "./chickenExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed9292",
  null
  
)

export default component.exports